export default {
    title: "Join Us",
    subtitle: "Become part of the crew",
  }